const CLASS_TOP="top";
const CLASS_FIXED="fijo";
const CLASS_BOTTOM="bottom";
const MINIMUM_HEIGHT=150;

/**
 * @author David Díaz <ddsanantonio@abc.es>
 * @author Felipe Galindo <fgalindo@vocento.com>
 */
function StickyHome() {

//    if (StickyHome.prototype._singletonInstance) {
//      return StickyHome.prototype._singletonInstance;
//    }
//    StickyHome.prototype._singletonInstance = this;
    if (window.stickyHome) {
        return window.stickyHome;
    }

    /**
     * Datos del Elemento al que hacer sticky
     * @typedef {Object} StickyItem
     * @property {HTMLElement} ele - Elemento sticky
     * @property {int} alto - Alto del elemento en pixels
     * @property {HTMLElement} padre - Contenedor del sticky
     * @property {int} altoPadre - Alto del contenedor
     * @property {int} recorrido - Espacio disponible para mover el sticky
     * @property {string} clase - Estilos asignado al elemento (top|fixed|bottom)
     * @property {boolen} activo - Indica si realizar sticky al elemento
     */

    /** @var {StickyItem[]}  */
    var robapaginas = [];
    var initialized = false;
    var paddingTop = 64;
    var paddingBottom = 23;

    function getRobas() {
        return robapaginas;
    }

    /**
     * @param {HTMLElement} ele 
     */
    function addElement(ele) {
        // Si ya está insertado no hacer nada
        for (let i=0, n=robapaginas.length; i<n; i++) {
            if (ele === robapaginas[i].ele) {
                return;
            }
        }

        ele.classList.add(CLASS_TOP);
        var roba = {
            'ele': ele,
            'alto': ele.offsetHeight,
            'padre': ele.parentElement,
            'altoPadre': ele.parentElement.offsetHeight,
            'recorrido': ele.parentElement.offsetHeight - ele.offsetHeight - paddingBottom,
            'activo': false,
            'clase': CLASS_TOP
        };
        robapaginas.push(roba);
        //Logger.info('sticky addElement', roba);
    }

    /**
     * @param {StickyItem} roba
     */
    function robaAltoAddClass(roba) {
        if(roba.alto > 250 && roba.altoPadre < 623) {
            roba.padre.classList.add('alto');
        }
    }

    function iniciar(top, bottom) {
        if (initialized) return;
        if (top) {
            paddingTop = top;
        }
        if (bottom) {
            paddingBottom = bottom;
        }
        document.addEventListener('scroll', function() {
            let roba;
            for (let i=0, n=robapaginas.length; i<n; i++) {
                roba = robapaginas[i];
                recalcular(roba);
                sticky(roba);
            }
        });
        initialized = true;
    }

    /**
     * @param {StickyItem} roba
     */
    function sticky(roba) {
        if(roba.activo) {
            var top = paddingTop - roba.padre.getBoundingClientRect().top;
            if ((top >= 0) && (top <= roba.recorrido)) {
                if (roba.clase === CLASS_FIXED) return;
                roba.ele.classList.remove(roba.clase);
                roba.ele.classList.add(CLASS_FIXED);
                roba.clase = CLASS_FIXED;
            } else if (top < 0) {
                if (roba.clase === CLASS_TOP) return;
                roba.ele.classList.remove(roba.clase);
                roba.ele.classList.add(CLASS_TOP);
                roba.clase = CLASS_TOP;
            } else {
                if (roba.clase === CLASS_BOTTOM) return;
                roba.ele.classList.remove(roba.clase);
                roba.ele.classList.add(CLASS_BOTTOM);
                roba.clase = CLASS_BOTTOM;
            }
        }
        else if (roba.clase !== CLASS_TOP) {
            roba.ele.classList.remove(roba.clase);
            roba.ele.classList.add(CLASS_TOP);
            roba.clase = CLASS_TOP;
        }
    }

    function recalcularTodo() {
        let roba;
        for (let i=0, n=robapaginas.length; i<n; i++) {
            roba = robapaginas[i];
            recalcular(roba);
            robaAltoAddClass(roba);
            sticky(roba);
        }
    }

    /**
     * @param {StickyItem} roba
     */
    function recalcular(roba) {
        roba.altoPadre = roba.padre.offsetHeight;
        roba.alto = roba.ele.offsetHeight;
        roba.recorrido = roba.altoPadre - roba.alto - paddingBottom;
        roba.activo = roba.recorrido > MINIMUM_HEIGHT;
        //Logger.debug('recalcular', roba);
    }

    return window.stickyHome = {
        "addElement": addElement,
        "iniciar": iniciar,
        "getRobas": getRobas,
        "recalcularTodo": recalcularTodo,
        "setTop": function(val){paddingTop=val;},
        "setBottom": function(val){paddingBottom=val;},
    };
}

export default StickyHome;



// WEBPACK FOOTER //
// ./src/scripts/home/sticky-home.js